/* istanbul ignore file */
import React, {Suspense} from "react"
import {useTemplatedComponent} from "@next/templating"
import {MANIFEST} from "@manifest/footer"
import connect from "./connect"

export const Footer = ({...props}) => {
    const TemplateComponent = useTemplatedComponent(props.template, MANIFEST)
    return (
        <Suspense>
            <TemplateComponent key={1} {...props} />
        </Suspense>
    )
}

export default connect(Footer)
